<template>
  <div
    class="d-flex justify-space-between align-center yard-view-list-header flex-wrap flex-md-nowrap">
    <div class="d-flex flex-row gap-4 align-center flex-wrap flex-md-nowrap">
      <v-text-field
        v-model="search"
        @update:model-value="$emit('update:search', $event?.trim())"
        variant="outlined"
        :placeholder="`${t('yard.pages.yardView.placeholders.searchThisTable')}...`"
        prepend-inner-icon="mdi-magnify"
        single-line
        hide-details
        class="max-width-300"
        density="compact" />

      <v-checkbox
        v-model="showWaitingAssets"
        density="compact"
        hide-details
        :label="t('yard.pages.yardView.labels.showWaitingAssets')"
        @update:model-value="$emit('update:showWaitingAssets', $event)" />
    </div>

    <div class="d-flex gap-4 align-center flex-wrap flex-md-nowrap">
      <yard-view-list-view-column-select
        :columns="toggleableColumns"
        @update:visibleColumns="$emit('update:visibleColumns', $event)" />

      <v-btn variant="outlined" disabled title="Available soon">
        <template #prepend>
          <v-icon>mdi-printer-outline</v-icon>
        </template>
        {{ t('global.basicTerms.print') }}
      </v-btn>
      <v-btn class="bg-primary" disabled title="Available soon">
        {{ t('global.buttons.export') }}
      </v-btn>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import YardViewListViewColumnSelect from '../Selects/YardViewListViewColumnSelect.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewListViewHeader',
  components: {
    YardViewListViewColumnSelect
  },
  props: {
    toggleableColumns: {
      type: Array,
      required: true
    }
  },
  emits: ['update:search', 'update:visibleColumns', 'update:showWaitingAssets'],
  setup() {
    const { t } = useI18n();
    const search = ref('');
    const showWaitingAssets = ref(true);

    return {
      showWaitingAssets,
      search,
      t
    };
  }
});
</script>
<style lang="scss">
.yard-view-list-header {
  .max-width-300 {
    min-width: 300px !important;
    max-width: 300px !important;
  }
}
</style>
